import { defineMessages } from 'react-intl';


export default defineMessages({
  instructionHeaderTitle: {
    id: 'app.containers.Photomanager.InstructionsHeaders.Title',
    defaultMessage: 'Envio de Fotos 360',
  },
  instructionHeaderSubtitle: {
    id: 'app.containers.Photomanager.InstructionsHeaders.Subitle',
    defaultMessage: 'Selecione as mídias feitas nessa sessão',
  },
  instructionHeaderCardTitle: {
    id: 'app.containers.Photomanager.InstructionsHeaders.CardTitle',
    defaultMessage: 'Requisitos para enviar suas fotos',
  },
  instructionHeaderCardDescription: {
    id: 'app.containers.Photomanager.InstructionsHeaders.CardDescription',
    defaultMessage: 'Envie as fotos 360 na ordem do checklist: ',
  },
  instructionHeaderCardDescriptionItems: {
    id: 'app.containers.Photomanager.InstructionsHeaders.CardDescriptionItems',
    defaultMessage: 'Sala / Banheiro / Quarto / Cozinha / Área de serviço / Condomínio',
  },
  secondInstructionHeaderCardDescription: {
    id: 'app.containers.Photomanager.InstructionsHeaders.SecondCardDescription',
    defaultMessage: 'As fotos 360° devem ter menos que ',
  },
  secondInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photomanager.InstructionsHeaders.SecondCardDescriptionItem',
    defaultMessage: '10Mb',
  },
  thirdInstructionHeaderCardDescription: {
    id: 'app.containers.Photomanager.InstructionsHeaders.ThirdCardDescription',
    defaultMessage: 'Formato ',
  },
  thirdInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photomanager.InstructionsHeaders.ThirdCardDescriptionItems',
    defaultMessage: 'JPEG',
  },
  fourthInstructionHeaderCardDescription: {
    id: 'app.containers.Photomanager.InstructionsHeaders.FourthCardDescription',
    defaultMessage: 'Sugerimos que use o tamanho ',
  },
  fourthInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photomanager.InstructionsHeaders.FourthCardDescriptionItems',
    defaultMessage: '2400x1600',
  },
  successUpdatePhotospheres: {
    id: 'app.containers.Photomanager.UpdatePhotospheres.Success',
    defaultMessage: 'Fotos salvas com sucesso!',
  },
  failureUpdatePhotospheres: {
    id: 'app.containers.Photomanager.UpdatePhotospheres.Failure',
    defaultMessage: 'Erro ao salvar as fotos!',
  },
  successUploadPhotos: {
    id: 'app.containers.Photomanager.UploadPhotos.Success',
    defaultMessage: 'Fotos enviadas com sucesso!',
  },
  failureUploadPhotos: {
    id: 'app.containers.Photomanager.UploadPhotos.Failure',
    defaultMessage: 'Erro ao enviar as fotos!',
  },
});
